"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepCheckout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const premium_company_profile_modal_context_1 = require("@src/context/premium-company-profile-modal-context");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const Api = __importStar(require("api"));
const antd_1 = require("antd");
const PremiumCompanyProfileSubscriptionModal_1 = require("./PremiumCompanyProfileSubscriptionModal");
const order_1 = __importDefault(require("../order"));
const StepCheckout = ({ setCurrentStep, selectedSubscriptionPeriod, onOrderSuccess }) => {
    const { setIsPremiumCompanyProfileSubscriptionModalOpen } = (0, premium_company_profile_modal_context_1.usePremiumCompanyProfileModalContextValue)();
    const intl = (0, react_intl_1.useIntl)();
    const { companyInfo } = (0, admin_context_1.useAdminContextValue)();
    const isCompanyOutOfContext = !companyInfo.id;
    const { data: fetchedCompany } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getCompany, Api.Company.getCompany, {
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        },
        enabled: isCompanyOutOfContext,
    });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(order_1.default, { productId: types_1.ProductId.companyPremium, amount: selectedSubscriptionPeriod, onOrderSuccess: onOrderSuccess, ...(isCompanyOutOfContext && { companyOutOfContext: fetchedCompany }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-center m-t-l", children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-s", size: "middle", type: "ghost", onClick: () => setIsPremiumCompanyProfileSubscriptionModalOpen(false), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.cancel" }) }), (0, jsx_runtime_1.jsxs)(elements_1.Button, { className: "m-s", size: "middle", type: "ghost", onClick: () => setCurrentStep(PremiumCompanyProfileSubscriptionModal_1.EPremiumCompanySubscriptionModalSteps.PREMIUM_COMPANY_PROFILE), children: [(0, jsx_runtime_1.jsx)(icons_1.LeftOutlined, {}), (0, jsx_runtime_1.jsx)("span", { className: "m-l-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.back_to_period_selection" }) })] })] })] }));
};
exports.StepCheckout = StepCheckout;
